export default __webpack_public_path__ + "static/media/IMG-20240708-WA0003.b1030775.jpg";